<template>
    <!-- 筛选栏 -->
    <el-card class="filter-card" shadow="never">
        <el-form :inline="true" :model="filters" class="filter-form">
            <el-form-item label="统计类型">
                <el-select v-model="filters.type" class="level-select">
                    <el-option label="每日快照" value="daily" />
                    <el-option label="每周快照" value="weekly" />
                    <el-option label="每月快照" value="monthly" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>
            </el-form-item>
        </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
        <div class="table-wrapper">
            <el-table :data="rows" v-loading="loading" style="width: 100%">
                <el-table-column prop="duration" label="统计周期" width="200">
                    <template #default="scope">
                        {{ scope.row.start }} ~ {{ $formatTime(new Date(scope.row.end).getTime() - 24 * 60 * 60 * 1000,
                        "yyyy-MM-DD") }}
                    </template>
                </el-table-column>
                <el-table-column v-for="col in cols" :key="col.prop" :prop="col.prop" :label="col.title" width="150">
                    <template #default="scope">
                        {{ scope.row.data[col.prop] || 0 }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
            <el-pagination v-model:current-page="filters.page" v-model:page-size="filters.size"
                :page-sizes="[10, 20, 50]" :total="filters.total" layout="total, sizes, prev, pager, next, jumper"
                @current-change="loadData" @size-change="loadData" />
        </div>
    </el-card>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { apiCall } from "@/utils/api";

const route = useRoute();
const router = useRouter();

const loading = ref(false);

const rows = ref([]);

const filters = reactive({
    type: route.query.type || "daily",
    page: Number(route.query.page) || 1,
    size: Number(route.query.size) || 20,
    total: 0,
});

const cols = [
    { title: "新增用户数", prop: "newUserCount" },
    { title: "总用户数", prop: "totalUserCount" },
    { title: "抽卡次数", prop: "newDrawCount" },
    { title: "总抽卡次数", prop: "totalDrawCount" },
    { title: "抽卡消费数", prop: "newDrawCost" },
    { title: "总抽卡消费数", prop: "totalDrawCost" },
];

watch(
    filters,
    (val) => {
        router.replace({ query: { ...val } });
    },
    { deep: true }
);

async function loadData() {
    loading.value = true;

    const params = {
        page: filters.page || 1,
        size: filters.size || 20,
    };
    if (filters.type) {
        params.type = filters.type;
    }

    const response = await apiCall("snapshot.getDatas", params);
    if (!response) {
        return false;
    }
    filters.total = response.count;
    rows.value = response.rows;

    loading.value = false;
}

onMounted(async () => {
    await loadData();
});
</script>

<style scoped>
.level-select {
    width: 100px;
}
</style>
